import React from 'react';
import { Link } from 'react-router-dom';
import { FaRegWindowClose } from 'react-icons/fa';

//services
import AppMembershipsService from './../AppMembershipsService';

//global components
import ModalButton from '../../../shared/Buttons/ModalButton';

//hooks
import { useRouter } from '../../../shared/hooks/useRouter';

//styles
import {
  ModalStyles,
  ModalContainerStyles,
  ModalHeaderStyles,
  ModalContentStyles,
  ModalItemStyles,
} from '../../../SharedStyles';

const UpgradeModal = (props) => {
  const { strings } = AppMembershipsService;
  const { handleCloseModal, subscriptionLevel } = props;
  const router = useRouter();

  const closeModal = () => {
    handleCloseModal();
  };

  const redirectModal = () => {
    router.history.push('/subscription/memberships');
  };

  return (
    <ModalStyles>
      <ModalContainerStyles>
        {/* Header Bar */}
        <ModalHeaderStyles>
          <h2 className='Title'>{strings.smallBizDeny}</h2>
          <FaRegWindowClose className='Close' onClick={closeModal} />
        </ModalHeaderStyles>
        {/* Content Section */}
        <ModalContentStyles>
          {/* Section */}
          <ModalItemStyles padding='0 10px'>
            <p>
              {subscriptionLevel === 1 ? strings.sharedDenyMessageOne : strings.smallBizDenyMessageOne}
              <Link to='/subscription'>{strings.enterpriseUpgrade}</Link>{' '}
              {strings.smallBizDenyMessageTwo}
            </p>
          </ModalItemStyles>
          {/* Section */}
        </ModalContentStyles>
        {/* Button Component for Modals*/}
        <ModalButton
          containerMargin='10px 10px 0'
          containerAlign='right'
          buttonPadding='10px'
          buttonMargin='0'
          handleClick={props.redirect ? redirectModal : closeModal}
          buttonText={strings.ok}
        />
      </ModalContainerStyles>
    </ModalStyles>
  );
};

export default UpgradeModal;
